import React, { useState } from 'react';

function DashboardMiniCal({ dates, onDateClick, label }) {
  const today = new Date();
  const [mo, setMo] = useState(today.getMonth());
  const [yr, setYr] = useState(today.getFullYear());
  const DAYS = ['Su','Mo','Tu','We','Th','Fr','Sa'];
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const first = new Date(yr, mo, 1).getDay();
  const dim = new Date(yr, mo+1, 0).getDate();
  const ds = (d) => `${yr}-${String(mo+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
  const todayStr = today.toISOString().split('T')[0];
  const prev = () => { if(mo===0){setMo(11);setYr(y=>y-1);}else setMo(m=>m-1); };
  const next = () => { if(mo===11){setMo(0);setYr(y=>y+1);}else setMo(m=>m+1); };
  return (
    <div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
        <button onClick={prev} style={{background:'none',border:'none',color:'#c8a84b',cursor:'pointer',fontSize:16,fontWeight:700}}>‹</button>
        <div style={{fontSize:13,fontWeight:700,color:'#e8c97a'}}>{MONTHS[mo]} {yr}</div>
        <button onClick={next} style={{background:'none',border:'none',color:'#c8a84b',cursor:'pointer',fontSize:16,fontWeight:700}}>›</button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:2,textAlign:'center'}}>
        {DAYS.map(d=><div key={d} style={{fontSize:9,color:'#a89a8a',fontWeight:600,padding:2}}>{d}</div>)}
        {Array(first).fill(null).map((_,i)=><div key={'e'+i}/>)}
        {Array(dim).fill(null).map((_,i)=>{
          const d=i+1, s=ds(d), info=dates[s];
          const isToday=s===todayStr;
          const bg = info?.type==='accepted'?'#1a6b3a':info?.type==='pending'?'#c8a84b':info?.type==='event'?'#c8a84b':'transparent';
          const color = info?'#fff':(isToday?'#c8a84b':'#7a6a5a');
          return (
            <div key={d} onClick={()=>info&&onDateClick&&onDateClick(s,info)}
              style={{fontSize:11,fontWeight:isToday?800:500,color,background:bg,borderRadius:4,padding:'3px 0',
                cursor:info?'pointer':'default',border:isToday&&!info?'1px solid #c8a84b':'1px solid transparent',
                lineHeight:'18px',minHeight:20}}>
              {d}
            </div>
          );
        })}
      </div>
      {label && <div style={{fontSize:10,color:'#a89a8a',textAlign:'center',marginTop:6}}>{label}</div>}
    </div>
  );
}

export default DashboardMiniCal;
